import { createAsyncThunk } from '@reduxjs/toolkit'

const logout = createAsyncThunk('auth/logout', async () => {
  return new Promise((resolve) => {
    resolve()
  })
})

export default logout
